import React from 'react';
import './StaticPageShell.css';

/**
 * StaticPageShell – standard layout for content pages (Press, Newsletter, Events, etc.).
 * Uses only CSS variables from config (/.platform_fe_*_config → /config/theme.css).
 * No hardcoded colours; theme controlled centrally.
 * headerActions: optional React node(s) rendered in the header (e.g. PDF download button).
 */
const StaticPageShell = ({ title, lead, headerActions, children, className = '', contentClassName = '' }) => (
  <div className={`static-page-shell ${className}`.trim()}>
    <div className="static-page-shell__header">
      <div className="static-page-shell__header-content">
        <div className="static-page-shell__title-section">
          {title && <h1 className="static-page-shell__title">{title}</h1>}
          {lead && <p className="static-page-shell__lead">{lead}</p>}
        </div>
        {headerActions && <div className="static-page-shell__header-actions">{headerActions}</div>}
      </div>
    </div>
    <div className={`static-page-shell__content ${contentClassName}`.trim()}>
      {children}
    </div>
  </div>
);

export default StaticPageShell;
